import { observer } from 'mobx-react';
import * as React from 'react';
import { AlreadyTranslated, AlreadyTranslatedText, T } from '../../../../../../../Translations';
import ListIcon from '../../../../../../Cutesies/ListIcon';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { SectionContext } from '../../../../Types';

interface Props {
  context: SectionContext;
  learningCollectionStore: LearningCollectionEditStore;
  learningDesignName: AlreadyTranslatedText;
}

const Heading: React.FC<Props> = ({ context, learningCollectionStore, learningDesignName }) => (
  <div className="mt-24 px-11">
    <div className="absolute inset-x-0 flex justify-between bg-[#187a9040] px-11 py-5 text-sm">
      <p>
        <T
          kind="Adding to <learningDesign/>"
          learningDesign={
            <span className="text-teal-600">
              <AlreadyTranslated content={learningDesignName} />
            </span>
          }
        />
      </p>
      <div className="flex">
        <ListIcon />
        <p className="ml-2">
          <T
            kind="{{count}} program"
            count={learningCollectionStore.experienceStores(context).length}
          />
        </p>
      </div>
    </div>
  </div>
);

export default observer(Heading);
